import { position } from "../core/position";
import { Component } from "./component";

export function DropdownButtonFactory(
  element: HTMLElement,
  blazorElement: any
) {
  return new DropdownButton(element, blazorElement);
}

export enum DropdownPosition {
  TopLeft,
  Top,
  TopRight,
  Bottom,
  BottomLeft,
  BottomRight,
  LeftTop,
  LeftBottom,
  RightTop,
  RightBottom,
}

export class DropdownButton extends Component {
  autoHide: boolean = true;
  isVisible = false;
  triggerElement: HTMLElement;

  constructor(public element: HTMLElement, public blazorElement: any) {
    super(element, blazorElement);
  }

  initialize() {
    document.addEventListener("click", (event) => { 
      const isClickInsideElement = this.element.contains(event.target as HTMLElement); 
      const isClickInsideTrigger = this.triggerElement?.contains(event.target as HTMLElement);
      const isClickInside = isClickInsideElement || isClickInsideTrigger;

      if (!isClickInside && this.autoHide && this.isVisible) {
          
        this.hide();
      }
    });
  }

  show(
    autoHide: boolean,
    ddPosition: DropdownPosition,
    triggerElement: HTMLElement
  ) {
    this.autoHide = autoHide;
    this.triggerElement = triggerElement;

    let p = position(triggerElement);
    let ep = position(this.element);

    console.log(
      `x = ${p.x}, y = ${p.y}, width = ${p.width}, height = ${p.height}`
    );

    let x = 0;
    let y = 0;

    // set location of dropdown based on ddposition
    switch (ddPosition) {
      case DropdownPosition.BottomLeft:
        {
          x = p.x;
          y = p.y + p.height;
        }
        break;
      case DropdownPosition.BottomRight:
        {
          x = p.x + p.width - this.element.offsetWidth;
          y = p.y + p.height;
        }
        break;
    }

    this.element.classList.remove("invisible");
    this.element.classList.add("animate-slide-left");   
    this.element.style.top = y + "px";
    this.element.style.left = x + "px";

    this.isVisible = true;
  }

  hide() {
    console.log("hiding");

    this.element.classList.add("invisible");

    this.isVisible = false;
  }
}
